import subAPI from '../../../api/init';

export default {
  /**
   * Whenever there is a fetch to backend - Calling this function allows
   * us to keep track when the call has initiated or has ended.
   *
   * @param {Boolean} isLoading - Initiate loading or end it.
   */
  toggleIsAppLoading({ isLoading }) {
    this.appLoading = isLoading;
  },

  /**
   * Fetch all avaiable betMakers products
   */
  fetchAllBetMakersProducts() {
    this.toggleIsAppLoading({ isLoading: true });

    subAPI
      .post(`/api.public.Public/GetAllProducts`)
      .then((res) => {
        this.products = res?.data?.products ?? [];
        this.toggleIsAppLoading({ isLoading: false });
      })
      .catch(() => {
        this.toggleIsAppLoading({ isLoading: false });
        // TODO: Add error logger like datadog or sentry (Helps identifiy issues in production)
      });
  },

  /**
   * Fetch all avaiable betMakers sub levels
   */
  fetchAllBetMakersSubLevels() {
    this.toggleIsAppLoading({ isLoading: true });

    subAPI
      .post(`/api.public.Public/GetAllSubscriptionLevels`)
      .then((res) => {
        this.subscriptionLevels = res?.data?.subscriptionLevels ?? [];
      })
      .catch((err) => {
        console.log(err, 'Something went wrong fetchAllSubscriptionLevels...');
      });
  },

  /**
   * Fetch all active/inactive customers
   */
  fetchActiveAndInactiveUsers() {
    this.toggleIsAppLoading({ isLoading: true });

    subAPI
      .post(`/api.public.Public/GetProductsWithCustomers`)
      .then((res) => {
        this.productsWithCustomers = res?.data?.products ?? [];
        this.toggleIsAppLoading({ isLoading: false });
      })
      .catch(() => {
        this.toggleIsAppLoading({ isLoading: false });
        // TODO: Add error logger like datadog or sentry (Helps identifiy issues in production)
      });
  },

  /**
   * Save selected product to local storage
   */
  setSelectedProduct({ productName }) {
    this.selectedProduct = productName;
    localStorage.setItem('selectedProduct', JSON.stringify(productName));
  },

  /**
   * Fetch all users
   */
  async fetchAllUsers() {
    this.toggleIsAppLoading({ isLoading: true });

    await subAPI
      .post(`/api.public.Public/GetAllCustomers`)
      .then((res) => {
        this.toggleIsAppLoading({ isLoading: false });
        this.allCustomers = res?.data?.customers ?? [];
      })
      .catch(() => {
        this.toggleIsAppLoading({ isLoading: false });
      });
  },

  fetchAllSubscriptionTypes() {
    subAPI
      .post(`/api.public.Public/GetAllSubscriptionTypes`)
      .then((res) => {
        this.subscriptionTypes = res?.data?.subscriptionTypes ?? [];
      })
      .catch((err) => {
        console.log(err, 'Something went wrong fetchAllSubscriptionTypes...');
      });
  },
  /**
   * Fetches all users associated with provided product ID
   */
  fetchCustomersByProductId({ productId }) {
    this.toggleIsAppLoading({ isLoading: true });
    const productIdFromStringToNumber = Number(productId);
    subAPI
      .post(`/api.public.Public/GetCustomersByProduct`, { productId: productIdFromStringToNumber })
      .then((res) => {
        this.toggleIsAppLoading({ isLoading: false });
        res?.data?.customers?.forEach((customer) => {
          customer.productId = productId;
        });
        this.customersByProduct = res?.data?.customers ?? [];
      })
      .catch(() => {
        this.toggleIsAppLoading({ isLoading: false });
      });
  },

  /**
   * Get customer's subscriptions
   */
  async getCustomerSubscriptions({ customer }) {
    this.customerSelected = customer;
    subAPI
      .post(`/api.public.Public/GetSubscriptionsByEmail`, {
        email: customer.email,
        userName: customer.username,
      })
      .then((res) => {
        this.toggleIsAppLoading({ isLoading: false });
        this.customerSubscriptions = res?.data?.subscriptions ?? [];
      })
      .catch(() => {
        this.toggleIsAppLoading({ isLoading: false });
      });
  },

  /**
   * Delete customer
   */
  deleteCurrentCustomer({ customerId }) {
    const isAllCustomerPath = window.location.pathname === '/all-customer-list';

    if (isAllCustomerPath) {
      const filterd = this.allCustomers.filter((customer) => customerId !== customer.id);
      this.allCustomers = filterd;
    } else {
      const filterd = this.customersByProduct.filter(
        (customer) => customerId !== customer.customerId,
      );
      this.customersByProduct = filterd;
    }

    subAPI
      .post('/api.public.Public/DeleteCustomer', { id: customerId })
      .then(() => {
        this.toggleIsAppLoading({ isLoading: false });
      })
      .catch(() => {
        this.toggleIsAppLoading({ isLoading: false });
      });
  },

  /**
   * Update customer data
   */
  async updateCurrentCustomer({ customer }) {
    this.toggleIsAppLoading({ isLoading: true });
    let result = {
      success: false,
      message: '',
    };
    try {
      const res = await subAPI.post(`/api.public.Public/UpdateCustomer`, {
        ...customer,
        notes: customer.customerNotes,
      });
      result.success = res?.status === 200;
      result.message = res?.response?.data?.message ?? 'Customer updated successfully';
    } catch (err) {
      result.success = false;
      result.message = 'Something went wrong';
    }
    this.toggleIsAppLoading({ isLoading: false });
    return result;
  },

  /**
   * Fetch customer details
   */
  fetchCustomerDetails({ customerId }) {
    this.toggleIsAppLoading({ isLoading: true });
    const productIdFromStringToNumber = Number(customerId);

    subAPI
      .post(`/api.public.Public/GetCustomer`, { id: productIdFromStringToNumber })
      .then((res) => {
        this.toggleIsAppLoading({ isLoading: false });
        this.customerDetails = res?.data?.customer ?? {};
      })
      .catch(() => {
        this.toggleIsAppLoading({ isLoading: false });
      });
  },

  /**
   * Fetch user transaction history
   */
  fetchCustomerTransactionHistory({ subscriptionId }) {
    this.toggleIsAppLoading({ isLoading: true });
    subAPI
      .post('/api.public.Public/GetTransactionsHistory', {
        subscriptionId: Number(subscriptionId),
        endDate: '2099-12-31',
        startDate: '2020-01-01',
      })
      .then((res) => {
        this.toggleIsAppLoading({ isLoading: false });
        this.customerTransactionsHistory = res?.data?.transactions ?? [];
      })
      .catch(() => {
        this.toggleIsAppLoading({ isLoading: false });
      });
  },
  async createNewUser({ newUser }) {
    this.toggleIsAppLoading({ isLoading: true });
    let result = {
      success: false,
      message: '',
    };
    try {
      const res = await subAPI.post(`/api.public.Public/InsertCustomer`, {
        ...newUser,
        notes: newUser.customerNotes,
        fromDashboard: true,
      });
      result.success = res?.status === 200;
      result.message = res?.response?.data?.message ?? 'User created successfully';
    } catch (err) {
      result.success = false;
      result.message = err?.response?.data?.message ?? 'Something went wrong';
    }

    this.toggleIsAppLoading({ isLoading: false });
    return result;
  },

  /**
   * Create New product ()
   */
  async createNewProduct({ newProduct }) {
    this.toggleIsAppLoading({ isLoading: true });
    let result = {
      success: false,
      message: '',
    };
    try {
      const res = await subAPI.post(`/api.public.Public/UpsertProduct`, newProduct);
      result.success = res?.status === 200;
      result.message = res?.response?.data?.message ?? 'Product saved successfully';
    } catch (err) {
      result.success = false;
      result.message = err?.response?.data?.message ?? 'Something went wrong';
    }
    this.toggleIsAppLoading({ isLoading: false });
    return result;
  },

  /**
   * Create new subscription
   */
  async createNewSubscription(newSubscription) {
    let result = {
      success: false,
      message: '',
    };
    try {
      let customerId;
      const resGetCustomerMemberIddUsername = await subAPI.post(
        `/api.public.Public/GetCustomerMemberIdUsername`,
        {
          memberId: newSubscription.customer.memberId,
          userName: newSubscription.customer.username,
        },
      );

      if (resGetCustomerMemberIddUsername?.data?.customer.id > 0) {
        customerId = resGetCustomerMemberIddUsername?.data?.customer.id;
      } else {
        const res = await subAPI.post(`/api.public.Public/InsertCustomer`, {
          firstName: newSubscription.customer.firstName,
          lastName: newSubscription.customer.lastName,
          email: newSubscription.customer.email,
          subscriptionTypeName: newSubscription.customer.subscriptionTypeName,
          userName: newSubscription.customer.username,
          fromDashboard: true,
        });
        customerId = res?.data?.customerId;
      }

      const resCreateSub = await subAPI.post(`/api.public.Public/InsertSubscription`, {
        status: Number(newSubscription.customer.status),
        paymentType: newSubscription.customer.paymentType,
        gateway: 'EWAY', //not really meaningful
        notes: newSubscription.customer.subscriptionNotes,
        commercial: Number(newSubscription.customer.commercial) || 0,
        customerId: Number(customerId),
        subscriptionLevelId: newSubscription.customer.subscriptionLevelId,
        subscriptionTypeId: this.subscriptionTypes.find(
          (t) => t.name === newSubscription.customer.subscriptionTypeName,
        ).id,
        //customerRebillId: customerRebillId,
        expirationDate: newSubscription.customer.expirationDate,
      });
      result.success = resCreateSub?.status === 200;
      result.message = resCreateSub?.response?.data?.message ?? 'Subscription created successfully';
    } catch (e) {
      result.message = e.message;
      result.message = e?.response?.data?.message ?? 'Something went wrong';
    }
    return result;
  },

  /**
   * Update subscription
   */
  async updateSubscription(editData) {
    let result = {
      success: false,
      message: '',
    };
    try {
      const res = await subAPI.post(`/api.public.Public/UpdateSubscription`, {
        id: editData.subscriptionId,
        status: editData.status,
        gateway: editData.gateway,
        customerId: editData.customerId,
        subscriptionLevelId: editData.subscriptionLevelId,
        subscriptionTypeId: this.subscriptionTypes.find(
          (t) => t.name === editData.subscriptionTypeName,
        ).id,
        // customerRebillId: editData.customer.customerRebillId,
        expirationDate: editData.expirationDate,
        paymentType: editData.paymentType,
        commercial: editData.commercial,
        notes: editData.subscriptionNotes,
        firstName: editData.firstName,
        lastName: editData.lastName,
      });
      result.success = res?.status === 200;
      result.message = res?.response?.data?.message ?? 'Subscription updated successfully';
    } catch (e) {
      result.message = e?.response?.data?.message ?? 'Something went wrong';
      result.success = false;
    }
    return result;
  },

  /**
   * Cancel subscription
   */
  async cancelSubscription({ subscriptionId }) {
    let result = {
      success: false,
      message: '',
    };
    try {
      const res = await subAPI.post('/api.public.Public/CancelSubscription', {
        id: subscriptionId,
      });
      result.success = res?.status === 200;
      result.message = res?.response?.data?.message ?? 'Subscription cancelled successfully';
    } catch (e) {
      result.message = e?.response?.data?.message ?? 'Something went wrong';
      result.success = false;
    }
    return result;
  },

  /**
   * Restart EWAY rebill for an expired recurring subscription
   */
  async restartEwayRebill({ subscriptionId }) {
    let result = {
      success: false,
      message: '',
    };
    try {
      const today = new Date();
      const newDate = `${String(today.getDate()).padStart(2, '0')}/${String(
        today.getMonth() + 1,
      ).padStart(2, '0')}/${today.getFullYear()}`;
      const res = await subAPI.post('/api.public.Public/UpdateRecurringData', {
        subscriptionId: Number(subscriptionId),
        newDate: newDate,
      });
      result.success = res?.status === 200;
      result.message = result.success
        ? 'EWAY rebill restarted successfully'
        : 'Something went wrong';
    } catch (e) {
      result.message = e?.response?.data?.message ?? 'Something went wrong';
      result.success = false;
    }
    return result;
  },

  async enableUser(username) {
    let result = {
      success: false,
      message: '',
    };
    try {
      const res = await subAPI.post('/api.public.Public/UpdateCognitoStatus', {
        username,
        enabled: true,
      });
      result.success = res?.status === 200;
      if (result.success) result.message = 'Cognito user enabled';
      else result.message = 'Something went wrong';
    } catch (e) {
      result.message = 'Something went wrong';
      result.success = false;
    }
    return result;
  },

  async disableUser(username) {
    let result = {
      success: false,
      message: '',
    };
    try {
      const res = await subAPI.post('/api.public.Public/UpdateCognitoStatus', {
        username,
        enabled: false,
      });
      result.success = res?.status === 200;
      if (result.success) result.message = 'Cognito user disabled';
      else result.message = 'Something went wrong';
    } catch (e) {
      result.message = 'Something went wrong';
      result.success = false;
    }
    return result;
  },
};
